export const education = [
  {
    degree: "B.Tech in Computer Science",
    institution: "Vignan's Foundation for Science, Technology Research",
    duration: "2022 - 2026",
    board: "University",
    score: "Pursuing"
  },
  {
    degree: "XII (Senior Secondary)",
    institution: "Bihar School Examination Board",
    duration: "2019 - 2021",
    board: "Bihar School Examination Board",
    score: "82.6%"
  },
  {
    degree: "X (Secondary)",
    institution: "Bihar School Examination Board",
    duration: "2018 - 2019",
    board: "Bihar School Examination Board",
    score: "78.8%"
  }
];